import { createEvent, restore, sample } from 'effector'
import {
  DividendAccrued,
  DividendAccruedRequest,
  DividendAccruedResponse,
} from './types'
import { fx } from '../../../../../../libs'
import { $params } from '../../../../../../features/router'

export const dividendAccruedListMounted = createEvent<DividendAccruedRequest>()

export const getDividendAccruedList = fx<
  DividendAccruedRequest,
  DividendAccruedResponse
>({
  method: 'GET',
  url: `/nova/dividend_accrued/by_client`,
})

export const $dividendAccruedList = restore<DividendAccrued[]>(
  getDividendAccruedList.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfDividendAccruedList = restore(
  getDividendAccruedList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: dividendAccruedListMounted,
  source: $params,
  fn: (params, { limit, page, orderBy, orderDirection }) => {
    let clientID
    if (params) {
      clientID = params.clientID
    }

    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    return {
      query,
      url: `/nova/dividend_accrued/by_client/${clientID}`,
    }
  },
  target: getDividendAccruedList,
})
